import { lasPostMessageTypes, LasPostMessageType } from '../constants';
import { lasErrorInstanceMap } from './scLoanError';

export type LasClientMessage = {
  type: LasPostMessageType;
  payload: {
    success: boolean;
    code: number;
    message: string;
  };
};

const terminalMessageTypes: LasPostMessageType[] = [
  lasPostMessageTypes.COMPLETE,
  lasPostMessageTypes.USER_CANCELLED,
];

export const allowedDomains = ['.smallcase.com', '.creditcase.in'];

export const iframePermissions = {
  'geolocation': ['*'],
  'camera': ['*'],
  'clipboard-read': ['*'],
  'clipboard-write': ['*'],
  'web-share': ['*'],
};

export function listenForExitMessages(
  iframe: HTMLIFrameElement,
  signal?: AbortSignal,
) {
  let removeListener = () => null;
  const listenerPromise: Promise<MessageEvent<LasClientMessage>> = new Promise(
    (resolve, reject) => {
      // abort before we even start listening
      if (signal?.aborted) {
        reject(lasErrorInstanceMap.USER_CANCELLED);
        return;
      }
      const handler = (ev: MessageEvent<LasClientMessage | null>) => {
        if (
          !ev.data ||
          !allowedDomains.some((domain) => ev.origin.endsWith(domain))
        )
          return;
        // ignore messages from other iframes
        if (iframe && ev.source !== iframe.contentWindow) return;
        if (terminalMessageTypes.includes(ev.data.type)) {
          removeListener();
          resolve(ev);
        }
      };
      removeListener = () => window.removeEventListener('message', handler);
      window.addEventListener('message', handler);
      // cancel the wait when the caller aborts
      signal?.addEventListener(
        'abort',
        () => {
          removeListener();
          reject(lasErrorInstanceMap.USER_CANCELLED);
        },
        { once: true },
      );
    },
  );

  return listenerPromise;
}

export function setupAskOriginResponse() {
  window.addEventListener('message', (event) => {
    if (event.data.type === lasPostMessageTypes.ASK_APP_ORIGIN)
      (event.source as Window).postMessage(
        { type: lasPostMessageTypes.GIVE_APP_ORIGIN },
        '*',
      );
  });
}

export function injectLasDnsPrefetch() {
  LAS_IFRAME_ORIGINS.split(',').forEach((origin) => {
    if (document.head.querySelector(`link[rel="dns-prefetch"][href="${origin}"]`))
      return;
    const link = document.createElement('link');
    link.rel = 'dns-prefetch';
    link.href = origin;
    document.head.appendChild(link);
  });
}

